import React from "react";

const PageNotFound = () => {
  return (
    <div>
      <h1>oops, page not found</h1>
    </div>
  );
};

export default PageNotFound;
